import React, { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Icon, Label } from '@atlas/ui';

const TerminalQrCodePopup = ({ className, customHandleClose, footer, id, qrCode, text, title }) => {
  const handleClose = useCallback(() => {
    if (customHandleClose) {
      customHandleClose();
    } else {
      NotificationManager.removeNotification(id);
    }
  }, [customHandleClose, id]);

  return (
    <BasePopup className={cx(className, 'terminal-qr-modal')}>
      <button className="close-popup" onClick={handleClose} type="button">
        <Icon name="close" />
      </button>

      <div className="popup__content">
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />

        <div className="popup-qr">{qrCode}</div>

        <div className="popup-footer">{footer}</div>
      </div>
    </BasePopup>
  );
};

TerminalQrCodePopup.propTypes = {
  className: PropTypes.string,
  customHandleClose: PropTypes.func,
  footer: PropTypes.node,
  id: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  qrCode: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
};

export default TerminalQrCodePopup;
